import { PaginateRequest } from 'interfaces/api-request';
import { ApiResponse, ApiResponseWithPagination } from 'interfaces/api-response';
import { ExportBatchDownload, ExportSetting, ExportSettingDetail } from 'interfaces/export-setting';
import { getBaseHeaderApi } from '../services/apiHelper';
import { adminApi } from '../services/services';

export interface ExportAttendanceRequestBody {
    from_date: Date;
    until_date: Date;
    employee_id?: number | null;
}

export const adminExportApi = adminApi.injectEndpoints({
    endpoints(builder) {
        return {
            getExportListApi: builder.query<ApiResponseWithPagination<ExportSetting>, PaginateRequest>({
                query: (params) => ({
                    url: '/export/list',
                    method: 'GET',
                    headers: getBaseHeaderApi(),
                    params
                })
            }),
            getExportDetailApi: builder.query<ApiResponse<ExportSettingDetail>, { id: string }>({
                query: ({ id }) => ({
                    url: `/export/status/${id}`,
                    method: 'GET',
                    headers: getBaseHeaderApi()
                })
            }),
            exportSingleBatchApi: builder.mutation<ApiResponse<ExportBatchDownload>, { id: string }>({
                query: ({ id }) => ({
                    url: `/export/download/batch/${id}`,
                    method: 'POST',
                    headers: getBaseHeaderApi()
                })
            }),
            cancelExportApi: builder.mutation<ApiResponse<void>, { id: string }>({
                query: ({ id }) => ({
                    url: `/export/${id}/cancel`,
                    method: 'PATCH',
                    headers: getBaseHeaderApi()
                })
            }),
            deleteExportApi: builder.mutation<ApiResponse<void>, { id: string }>({
                query: ({ id }) => ({
                    url: `/export/${id}`,
                    method: 'DELETE',
                    headers: getBaseHeaderApi()
                })
            }),
            createAttendanceExportApi: builder.mutation<ApiResponse<{ export_request_id: string }>, ExportAttendanceRequestBody>({
                query: (body) => ({
                    url: '/export/attendance',
                    method: 'POST',
                    headers: getBaseHeaderApi(),
                    data: {
                        from_date: body.from_date,
                        until_date: body.until_date,
                        employee_id: body.employee_id
                    }
                })
            })
        };
    }
});

export const {
    useGetExportListApiQuery,
    useGetExportDetailApiQuery,
    useCancelExportApiMutation,
    useDeleteExportApiMutation,
    useCreateAttendanceExportApiMutation,
    useExportSingleBatchApiMutation
} = adminExportApi;
